// extracted by mini-css-extract-plugin
export default {"buttonContentContainer":"RequestTransferOrder_buttonContentContainer__O4cbT","flexContainer":"RequestTransferOrder_flexContainer__kuBkB"};